import { useRemoteData } from "@sinch/mfe-helper-react";
import { apiUrls } from "../api";
import { type MmUser, type MmUserPartial, MmUserZod } from "../api/types";

export const useFetchUser = (initialData?: MmUser, enabled = true) =>
  useRemoteData(apiUrls.userUrl, {
    useToken: true,
    initialData: initialData,
    enabled,
    parse: (data) => {
      const parsed = MmUserZod.safeParse(data);
      if (parsed.success) return parsed.data;
      const errorMessage = "Invalid response from userinfo";
      console.error(errorMessage, parsed.error);
      return data as MmUserPartial;
    },
  });
